import React, { useEffect, useState } from 'react';

declare global {
  interface Window {
    WAGCaptcha?: any;
  }
}

interface AwsCaptchaProps {
  onVerify: (token: string) => void;
}

const AwsCaptcha: React.FC<AwsCaptchaProps> = ({ onVerify }) => {
  const [captchaLoaded, setCaptchaLoaded] = useState(false);

  useEffect(() => {
    if (!window.WAGCaptcha) {
      const script = document.createElement('script');
      script.src =
        'https://acb1dbd65aa1.us-east-1.captcha-sdk.awswaf.com/acb1dbd65aa1/jsapi.js%22';
      script.async = true;
      script.onload = () => {
        console.log('AWS WAG CAPTCHA script loaded');
        setCaptchaLoaded(true);
      };
      document.body.appendChild(script);
    } else {
      setCaptchaLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (captchaLoaded && window.WAGCaptcha) {
      window.WAGCaptcha.render('aws-captcha-container', {
        siteKey:
          'EQKhZjqijgkFdms8E+X+1pnbHBQ0D9QxkXgxyeuFw/tk0CnJ5Yu/2PKrcG4wHT2jbm9onSVCeszHIAlF1BvdKw6PC1DUkP6b7mJAU8cV3Wc/bN3dQJE5bqctEk94SRA+c0ayPg0lrmHFWEucFNJo4+U1kivMVaRGM+/3EdYbkufRkUyjDhHhafJAcynlg+R2ZQJXYlBFuAgo9JofMQ3W0fQpTLNPH9gGiTpWKugjvWXO1NzHw90Da4/N4nvBgBuyzDJ4CAaJG3kOnJnC87i45+DEXjHrSb/WeMASRXaRwTGq3/cRr83wkCIOsTl8Y5j41C4Z/X9WdG6LJ0Y+8keuuMMlH4XhQ9i7yqQHMhc58DQeU4NtIi8itzJq1Ht3pauIx810wpuhqDPWYRNzkegARt1G34z23xyxUG7ouofLFJdWgAXpq0OjhkX1IN8gviey/PhWlSrJdiUWaeiZ7WybwntjNk06yKeXWfy8uFFWV6u+QV1Oto5tZv9L9Y5NW6zcZTvVjUAYg0hJGUymUHguCRsSSjMpXXdz2x48qbxJ2ih1p8EJTPayejLxj4WasA6/I/6VsaJCKQ8xsd0tLPoz6KX9/gwdWe1368ThUsFf9azzeWB8lnsTFsxASL7rOCVqdnLylGAhoi/OPpzk9auKu/xymx3ItYkNgPTirKTQcGM=_0_1', // Replace with actual AWS CAPTCHA site key
        callback: (token: string) => onVerify(token),
      });
    }
  }, [captchaLoaded, onVerify]);

  return <div id="aws-captcha-container"></div>;
};
export default AwsCaptcha;
